import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import {
  fontSize28,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  grey10,
  purple1,
  purple2,
  purple3,
} from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

export const VocabularyTitle = styled.div`
  background-color: ${purple2};
  border: 1px solid ${purple3};
  border-bottom: none;
  border-radius: ${rem(borderRadius8)} ${rem(borderRadius8)} 0 0;
  color: ${grey10};
  display: inline-block;
  font-size: ${rem(fontSize28)};
  font-weight: ${fontWeightMedium};
  margin-bottom: -${rem(1)};
  padding: ${rem(spacing8)};
`;

export const VocabularyList = styled.ul`
  ${baseFlexCss}

  background-color: ${purple1};
  border: 1px solid ${purple3};
  border-radius: 0 ${rem(borderRadius8)} ${rem(borderRadius8)}
    ${rem(borderRadius8)};
  flex-wrap: wrap;
  gap: ${rem(spacing8)};
  list-style: none;
  margin: 0;
  padding: ${rem(spacing8)};
`;

export const VocabularyListItem = styled.li`
  display: inline-block;
`;

export const VocabularyButton = styled(SecondaryButton)`
  font-size: ${rem(fontSize28)};
  height: auto;
  padding: ${rem(spacing16)} ${rem(spacing24)};
`;

export const VocabularyExtraButton = styled.div`
  position: absolute;
  right: 0;
  top: ${rem(spacing12)};
`;
